const Routes = require('../../routes').Routes;

export default [
  {
    title: 'Business analysis & Product design',
    list: ['Scope defining', 'Prototyping', 'UX review', 'UX/UI Product Design'],
  },
  {
    title: 'Quality Assurance and Control',
    list: ['Manual testing', 'Automated testing'],
  },
  {
    title: 'Web Development',
    list: [
      {
        title: 'Devops (Amazon, Azure)',
        to: Routes.SERVICES_DEVOPS,
      },
      {
        title: 'Node.js',
        to: Routes.TECHNOLOGIES_NODEJS,
      },
      {
        title: 'React.js',
        to: Routes.TECHNOLOGIES_REACTJS,
      },
      {
        title: 'Gatsby.js',
        to: Routes.TECHNOLOGIES_GATSBY,
      },
      {
        title: 'Blockchain',
        to: Routes.TECHNOLOGIES_BLOCKCHAIN,
      },
      'Ruby on Rails',
    ],
  },
  {
    title: 'Mobile Development',
    list: [
      {
        title: 'React Native',
        to: Routes.TECHNOLOGIES_REACT_NATIVE_JS,
      },
    ],
  },
];
